import React from "react";
import NavBar from "../../components/NavBar";
import { useHistory } from "react-router-dom";
import { AppContext } from '../../AppContext';
import Footer from "../../components/SessionFooter";

  const DockedArea: React.SFC<{}> = () => {

    const context = React.useContext(AppContext);
    let state = context.state;
    let history = useHistory();

    const dockedHighHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      state.current.dockedPosition = "high";
      context.setState(state);
      history.push('/tail_injury');
    }

    const dockedMiddleHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      state.current.dockedPosition = "middle";
      context.setState(state);
      history.push('/tail_injury');
    }

    const dockedLowHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      state.current.dockedPosition = "low";
      context.setState(state);
      history.push('/tail_injury');
    }
    const backHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      state.current.dockedPosition = "";
      context.setState(state);
      history.push('/tail_condition');
    }
    
    return (
      <>
        <NavBar
          backBtnTitle="Back"
          backBtnClick={backHandler}
          tag={context.state.current.tagNumber}
        />
        <h1>Where is the tail docked?</h1>
        <div className="content-pane">
            <button className="rpg_button" onClick={dockedHighHandler} >HIGH</button>
            <button className="rpg_button" onClick={dockedMiddleHandler} >MIDDLE</button>
            <button className="rpg_button" onClick={dockedLowHandler} >LOWER</button>  
        </div>
        <Footer tag={state.previous.tagNumber} />
      </>
     )
  }
export default DockedArea;